import React from "react";
import ModulesScreen from "../../screens/Modules/ModulesScreen";

const ModulesContainer = ({}) => {
  return <ModulesScreen />;
};

export default ModulesContainer;
